export default {
  "请输入手机号或用户名": "请输入手机号或用户名",
  "请输入密码": "请输入密码",
  "自动登录": "自动登录",
  "游戏试玩": "游戏试玩",
  "忘记密码": "忘记密码",
  "登录账户": "登录账户",
  "联系客服": "联系客服",
  "注册账户": "注册账户",
  "请输入确认密码": "请输入确认密码",
  "推荐人": "推荐人",
  "请输入验证码": "请输入验证码",
  "注册": "注册",
  "登录": "登录",
  "返回登录": "返回登录",
  "复制成功": "复制成功",
  "客服": "客服",
  "大厅": "大厅",
  "发现": "发现",
  "优惠": "优惠",
  "我的": "我的",
  "会话": "会话",
  "公告通知": "公告通知",
  "上下分如有问题请及时联系客服": "上下分如有问题请及时联系客服",
  "在线客服": "在线客服",
  "提供各类问题疑难排解": "提供各类问题疑难排解",
  "Telegram客服": "Telegram客服",
  "消息中心": "消息中心",
  "公告": "公告",
  "站内信": "站内信",
  "没有更多了": "没有更多了",
  "请先登录或者注册": "请先登录或者注册",
  "充值": "充值",
  "转账": "转账",
  "提现": "提现",
  "IOS用户注意": "iOS用户注意",
  "尊敬的U8会员您好": "尊敬的U8会员您好",
  "sys_content1": "U8国际iOS新版APP已完成修复并正式上线，现已开放下载。",
  "sys_content2": "但为确保永久访问稳定，建议您优先使用Safari浏览器打开",
  "sys_content3": "点击底部 📤“分享”按钮 → 选择 “添加到主屏幕”，即可快捷进入平台。",
  "sys_content4": "如需使用APP，请前往官网",
  "sys_content5": "首页，点击右上角【点击下载】按钮获取最新版。",
  "sys_content6": "如有疑问，请联系官方客服",
  "sys_content7": "协助处理。",
  "sys_content8": "感谢您的支持与理解！",
  "sys_content9": "U8国际运营团队",
  "公平": "公平",
  "公正": "公正",
  "公开": "公开",
  "官方投注机器人":  "官方投注机器人",
  "sys_content10": "直接进行游戏、充值、提现等操作。",
  "搜索": "搜索",
  "sys_content11": "感谢您的理解与支持，祝您游戏愉快！",
  "今日不再弹出": "今日不再弹出",
  "添加": "添加",
  "到手机主页屏幕": "到手机主页屏幕",
  "选择分享按钮": "到手机主页屏幕",
  "点击": "点击",
  "加至主画面": "加至主画面",
  "点击「加入」按钮": "点击「加入」按钮",
  "存款": "存款",
  "网银转账": "网银转账",
  "微信": "微信",
  "支付宝": "支付宝",
  "收款账号": "收款账号",
  "复制": "复制",
  "银行户名": "银行户名",
  "开户行": "开户行",
  "银行地址": "银行地址",
  "开户银行": "开户银行",
  "选择开户银行": "选择开户银行",
  "存款人姓名": "存款人姓名",
  "请输入存款人姓名": "请输入存款人姓名",
  "请务必输入正确的存款人姓名": "为及时到账，请务必输入正确的存款人姓名",
  "银行卡号": "银行卡号",
  "请输入银行卡号": "请输入银行卡号",
  "开户行地址": "开户行地址",
  "请输入开户行地址": "请输入开户行地址",
  "请输入银行开户行地址": "请输入银行开户行地址",
  "存款金额": "存款金额",
  "请输入取款金额": "请输入取款金额",
  "元": "元",
  "USDT价格稳定": "USDT价格稳定",
  "流通性高": "流通性高",
  "不受监管": "不受监管",
  "了解更多": "了解更多",
  "绑定协议地址": "绑定协议地址",
  "交易所划转": "交易所划转",
  "完成取款": "完成取款",
  "钱包协议": "钱包协议",
  "温馨提示": "温馨提示",
  "温馨提示内容": "请选择正确的USDT协议付款，若您选择错误的协议付款，平台将无法收到您的付款，为此我们不承担任何负责！",
  "立即存款": "立即存款",
  "存款遇到问题": "存款遇到问题",
  "联系": "联系",
  "人工客服": "人工客服",
  "解决": "解决",
  "银行类型": "银行类型",
  "请输入银行类型": "请输入银行类型",
  "请输入金额区间": "请输入金额在{min_price}-{max_price}之间！",
  "等待后台审核": "提交成功，等待后台审核",
  "场馆转账": "场馆转账",
  "余额自动转入": "余额自动转入",
  "启用后余额自动转入转出游戏场馆": "启用后余额自动转入转出游戏场馆",
  "请输入转账金额": "请输入转账金额",
  "全部转入": "全部转入",
  "可转账金额": "可转账金额",
  "确认转账": "确认转账",
  "场馆余额明细": "场馆余额明细",
  "点击查看全部场馆余额": "点击查看全部场馆余额",
  "主钱包": "主钱包",
  "一键取回": "一键取回",
  "收起": "收起",
  "展开": "展开",
  "请输入操作金额": "请输入操作金额",
  "场馆内钱包不支持互转": "场馆内钱包不支持互转",
  "操作成功": "操作成功",
  "VIP特权": "VIP特权",
  "已达标": "已达标",
  "未达标": "未达标",
  "累计存款": "累计存款",
  "流水要求": "流水要求",
  "VIP最高返水比例": "VIP最高返水比例",
  "VIP等级": "VIP等级",
  "真人": "真人",
  "体育": "体育",
  "电竞": "电竞",
  "棋牌": "棋牌",
  "电子": "电子",
  "彩票": "彩票",
  "活动规则": "活动规则",
  "晋升标准": "晋升标准",
  "rule_content1": "会员的累计存款以及累计流水达到相应级别的要求，即可在次日24点前晋级相应VIP等级。",
  "晋升顺序": "晋升顺序",
  "rule_content2": "VIP等级达到相应的要求可每天晋升一级，但VIP等级不可越级晋升。",
  "保级要求": "保级要求",
  "rule_content3": "会员在达到某VIP等级后，90天内投注需要完成保级流水要求。如果在此期间完成晋升，保级要求重新按照当前等级计算。",
  "降级标准": "降级标准",
  "rule_content4": "如果会员在一个季度（90天计算）内没有完成相应的保级要求流水，系统会自动降级一个等级，相应的返水及其它优惠也会随之调整至降级后的等级。",
  "VIP返水": "VIP返水",
  "rule_content5": "VIP返水优惠发放金额根据会员当天北京时间00:00—23:59之间的有效投注进行计算，当天所有的投注额返水将在注单结算当天结束后24小时内发放到福利中心，进入个人中心点击福利中心进行手动领取。（VIP返水1倍流水即可提款）",
  "rule_content6": "欧宝娱乐保留对活动的修改，停止及最终解释权",
  "取款": "取款",
  "银行卡取款": "银行卡取款",
  "钱包金额": "钱包金额",
  "一键回收": "一键回收",
  "中心钱包": "中心钱包",
  "游戏钱包": "游戏钱包",
  "选择USDT地址": "选择USDT地址",
  "请选择USDT地址": "请选择USDT地址",
  "添加USDT地址": "添加USDT地址",
  "打码量": "打码量",
  "取款金额": "取款金额",
  "最大金额": "最大金额",
  "支付密码": "支付密码",
  "请输入支付密码": "请输入支付密码",
  "每笔手续费": "每笔手续费",
  "折合USDT": "折合USDT",
  "参考汇率": "参考汇率",
  "实时变化": "实时变化",
  "实际到账": "实际到账",
  "选择银行卡": "选择银行卡",
  "请选择银行卡": "请选择银行卡",
  "添加银行卡": "添加银行卡",
  "立即取款": "立即取款",
  "取款遇到问题": "取款遇到问题",
  "真实姓名": "真实姓名",
  "绑定真实姓名后不可修改": "绑定真实姓名后不可修改",
  "确认修改": "确认修改",
  "请选择您要提现到的银行卡": "请选择您要提现到的银行卡",
  "单笔取款不能低于100元": "单笔取款不能低于100元",
  "请输入您的支付密码": "请输入您的支付密码",
  "请填写用户实名信息": "请填写用户实名信息",
  "提交成功": "提交成功",
  "优惠活动": "优惠活动",
  "全部优惠": "全部优惠",
  "限时活动": "限时活动",
  "新人首存": "新人首存",
  "日常活动": "日常活动",
  "暂未设置签名": "暂未设置签名",
  "账户总资产": "账户总资产",
  "我的钱包": "我的钱包",
  "账户明细": "账户明细",
  "投注记录": "投注记录",
  "安全设置": "安全设置",
  "我的等级": "我的等级",
  "VIP中心": "VIP中心",
  "邀请好友": "邀请好友",
  "推荐送礼金": "推荐送礼金",
  "官方公告": "官方公告",
  "坐收盈利": "坐收盈利",
  "合营计划": "合营计划",
  "加入我们": "加入我们",
  "月入百万": "月入百万",
  "NG扑克": "NG扑克",
  "活动中心": "活动中心",
  "平台优惠回馈活动": "平台优惠回馈活动",
  "输赢比例": "输赢比例",
  "功能设置": "功能设置",
  "反水比例": "反水比例",
  "反水中心": "反水中心",
  "修改登录密码": "修改登录密码",
  "个人资料": "个人资料",
  "个人头像": "个人头像",
  "用户名": "用户名",
  "请输入用户名": "请输入用户名",
  "请输入真实姓名": "请输入真实姓名",
  "出生日期": "出生日期",
  "请选择出入日期": "请选择出入日期",
  "手机号码": "手机号码",
  "绑定手机号保障账号安全": "绑定手机号，保障账号安全",
  "电子邮箱": "电子邮箱",
  "绑定邮箱保护账号安全": "绑定邮箱保护账号安全",
  "请输入正确手机号": "请输入正确手机号",
  "请输入正确邮箱号": "请输入正确邮箱号",
  "请输入正确的日期格式": "请输入正确的日期格式",
  "邀请链接": "邀请链接",
  "立即邀请": "立即邀请",
  "礼金介绍": "礼金介绍",
  "明细记录": "明细记录",
  "下级概览": "下级概览",
  "下级成员统计": "下级成员统计",
  "本月新增": "本月新增",
  "本月活跃成员": "本月活跃成员",
  "本月有效活跃": "本月有效活跃",
  "今日新增": "今日新增",
  "今日活跃": "今日活跃",
  "本月新增有效会员": "本月新增有效会员",
  "今日存款": "今日存款",
  "数据列表": "数据列表",
  "礼金记录": "礼金记录",
  "好友明细": "好友明细",
  "重置": "重置",
  "查询": "查询",
  "日期": "日期",
  "礼金": "礼金",
  "备注": "备注",
  "保存链接": "保存链接",
  "保存图片": "保存图片",
  "保存二维码": "保存二维码",
  "取消": "取消",
  "链接已复制到剪贴板": "链接已复制到剪贴板",
  "复制链接失败": "复制链接失败",
  "合营部": "合营部",
  "立即咨询": "立即咨询",
  "咨询": "咨询",
  "联系方式": "联系方式",
  "请输入您的联系方式": "请输入您的联系方式",
  "申请理由": "申请理由",
  "请输入申请理由": "请输入申请理由",
  "盈利总额": "盈利总额",
  "充值总额": "充值总额",
  "提现总额": "提现总额",
  "投注总额": "投注总额",
  "设置": "设置",
  "消息时间显示": "消息时间显示",
  "中奖提示": "中奖提示",
  "安静模式": "安静模式",
  "关于CG": "关于CG",
  "帮助与反馈": "帮助与反馈",
  "退出": "退出",
  "返水比例": "返水比例",
  "当日累计投注": "当日累计投注",
  "转运金": "转运金",
  "开元棋牌": "开元棋牌",
  "设置提现密码": "设置提现密码",
  "原密码": "原密码",
  "请输入当前密码": "请输入当前密码",
  "新密码": "新密码",
  "请输入新密码": "请输入新密码",
  "确认新密码": "确认新密码",
  "请再次输入密码": "请再次输入密码",
  "请输入旧密码": "请输入旧密码",
  "请输入正确的旧密码长度": "请输入正确的旧密码长度",
  "请输入正确的新密码长度": "请输入正确的新密码长度",
  "两次密码不一致": "两次密码不一致",
  "新旧密码不能一致": "新旧密码不能一致",
  "密码修改成功": "密码修改成功",
  "app下载": "app下载",
  "可扫描下发二维码进行app下载": "可扫描下发二维码进行app下载",
  "立即下载": "立即下载",
  "download_content1": "需在同一网络环境下下载安装注册，请勿切换网络； 若无法正常安装，请使用手机自带浏览器打开本页面",
  "请输入金额": "请输入金额",
  "转入": "转入",
  "平台钱包": "平台钱包",
  "操作金额不能为0": "操作金额不能为0",
  "转入成功": "转入成功",
  "天": "天",
  "时": "时",
  "分": "分",
  "秒": "秒",
  "剩余领取次数": "剩余领取次数",
  "次": "次",
  "主账号余额": "主账号余额",
  "账户充值": "账户充值",
  "账户提现": "账户提现",
  "下线转账": "下线转账",
  "订单号": "订单号",
  "金额": "金额",
  "空空如也": "空空如也",
  "今日": "今日",
  "近7日": "近7日",
  "近15日": "近15日",
  "近30日": "近30日",
  "转出": "转出",
  "赠送": "赠送",
  "反水": "反水",
  "未定义": "未定义",
  "待审核": "待审核",
  "审核通过": "审核通过",
  "审核拒绝": "审核拒绝",
  "失败": "失败",
  "成功": "成功",
  "待结算": "待结算",
  "全平台": "全平台",
  "大舞台": "大舞台",
  "官方动态": "官方动态",
  "动态": "动态",
  "活动申请记录": "活动申请记录",
  "活动标题": "活动标题",
  "申请时间": "申请时间",
  "状态": "状态",
  "未约定": "未约定",
  "通过": "通过",
  "拒绝": "拒绝",
  "派彩": "派彩",
  "无效注单": "无效注单",
  "已结算": "已结算",
  "未结算": "未结算",
  "返水中心": "返水中心",
  "返水记录": "返水记录",
  "点击领取": "点击领取",
  "累计领取": "累计领取",
  "待领取": "待领取",
  "返水金额": "返水金额",
  "返水时间": "返水时间",
  "领取时间": "领取时间",
  "暂未领取": "暂未领取",
  "暂无领取额度": "暂无领取额度",

  "加载中": "加载中",
  "最多支持添加5个地址": "最多支持添加5个地址",
  "认证失败": "认证失败",
  "您的账号登陆过期，请重新登陆": "您的账号登陆过期，请重新登陆",
  "提示": "提示",
  "您确定要退出登录吗": "您确定要退出登录吗",
  "精彩内容等你来体验，快来登录吧": "精彩内容等你来体验，快来登录吧",
  "立即下载APP": "立即下载APP",
  "余额": "余额",

  "活动详情": "活动详情",
  "活动说明": "活动说明",
  "立即申请": "立即申请",
  "前往登录": "前往登录",

  "代理系统": "代理系统",
  "下属代理": "下属代理",
  "代理总览": "代理总览",
  "直属玩家": "直属玩家",
  "盈亏统计": "盈亏统计",
  "账单查询": "账单查询",
  "充值记录": "充值记录",
  "提现记录": "提现记录",
  "个人信息": "个人信息",
  "下级在线": "下级在线",
  "我的余额": "我的余额",
  "附属代理人": "附属代理人",
  "附属玩家": "附属玩家",
  "今日投注": "今日投注",
  "今日收入": "今日收入",
  "历史收入": "历史收入",
  "邀请码": "邀请码",
  "开盘中": "开盘中",
  "已封盘": "已封盘",
  "下注倒计时": "下注倒计时",
  "期": "期",
  "期开奖结果": "期开奖结果",
  "已开启": "已开启",
  "已关闭": "已关闭",
  "期号": "期号",
  "号码": "号码",
  "总和": "总和",
  "总和两面": "总和两面",
  "首页": "首页",
  "上一页": "上一页",
  "下一页": "下一页",
  "尾页": "尾页",
  "请输入": "请输入",
  "下注": "下注",
  "大小单双": "大小单双",
  "大": "大",
  "小": "小",
  "单": "单",
  "双": "双",
  "大单": "大单",
  "大双": "大双",
  "小单": "小单",
  "小双": "小双",
  "形态": "形态",
  "豹子": "豹子",
  "对子": "对子",
  "顺子": "顺子",
  "极大": "极大",
  "极小": "极小",
  "特码": "特码",
  "清空": "清空",
  "立即下注": "立即下注",
  "开奖号码": "开奖号码",
  "第": "第",
  "投注时间": "投注时间",
  "投注金额": "投注金额",
  "玩法": "玩法",
  "盘类": "盘类",
  "派奖奖金": "派奖奖金",
  "赔率": "赔率",
  "返水": "返水",
  "总投注": "总投注",
  "有效投注": "有效投注",
  "总派奖": "总派奖",
  "实际派奖": "实际派奖",
  "两面": "两面",
  "组合": "组合",
  "每页": "每页",
  "条": "条",
  "编辑金额": "编辑金额",
  "恢复默认": "恢复默认",
  "保存": "保存",
  "距离开奖": "距离开奖",
  "刷新": "刷新",
  "返回": "返回",
  "当前第": "当前第",
  "数据统计详情": "数据统计详情",
  "值": "值",
  "未开期数": "未开期数",
  "单路区": "单路区",
  "间隔": "间隔",
  "咪牌": "咪牌",
  "投注区": "投注区",
  "游戏记录": "游戏记录",
  "路单区": "路单区",
  "游戏规则": "游戏规则",
  "开奖验证": "开奖验证",
  "开奖记录": "开奖记录",
  "统计": "统计",
  "大小": "大小",
  "极大小": "极大小",
  "已选": "已选",
  "注": "注",
  "共计": "共计",
  "已中奖": "已中奖",
  "未开奖": "未开奖",
  "已退款": "已退款",
  "语言": "语言",

  "六合彩": "六合彩",
  "初级": "初级",
  "猜特码": "猜特码",
  "猜特肖": "猜特肖",
  "猜平肖": "猜平肖",
  "猜类型": "猜类型",
  "平肖": "平肖",
  "鼠": "鼠",
  "牛": "牛",
  "虎": "虎",
  "兔": "兔",
  "龙": "龙",
  "蛇": "蛇",
  "马": "马",
  "羊": "羊",
  "猴": "猴",
  "鸡": "鸡",
  "狗": "狗",
  "猪": "猪",
  "类型": "类型",
  "蓝波": "蓝波",
  "绿波": "绿波",
  "红波": "红波",
  "特肖": "特肖",
  "特鼠": "特鼠",
  "特牛": "特牛",
  "特虎": "特虎",
  "特兔": "特兔",
  "特龙": "特龙",
  "特蛇": "特蛇",
  "特马": "特马",
  "特羊": "特羊",
  "特鸡": "特鸡",
  "特狗": "特狗",
  "特猪": "特猪",
  "特猴": "特猴",
  "什么也没有": "什么也没有",
  "进行中": "进行中",
  "已结束": "已结束",
  "快捷下注": "快捷下注",
  "开奖走势": "开奖走势",
  "开奖历史": "开奖历史",
  "在线": "在线",
  "快捷投注": "快捷投注",
  "项": "项",
  "需支付": "需支付",
  "确认投注": "确认投注",
  "错误提示": "错误提示",
  "管理员": "管理员",
  "封盘中": "封盘中",
  "预计盈利": "预计盈利",
  "投注成功": "投注成功",
  "用户": "用户",
  "时间": "时间",
  "投注": "投注",
  "加拿大28": "加拿大28",
  "中级": "中级",
  "新澳门六合彩": "新澳门六合彩",
  "澳门六合彩": "澳门六合彩",
  "下注内容": "下注内容",
  "合计总金额": "合计总金额",
  "房间": "房间",

  "更多新玩法等你来体验": "更多新玩法等你来体验",
  "精彩活动": "精彩活动",
  "代理联盟": "代理联盟",
  "始于成功": "始于成功",
  "臻于卓越": "臻于卓越",
  "鲤跃龙门": "鲤跃龙门",
  "投资传奇": "投资传奇",
  "VIP会员成长": "VIP会员成长",
  "晋级VIP会员": "晋级VIP会员",
  "享顶级至尊服务": "享顶级至尊服务",
  "确认添加": "确认添加",





}



// WEBPACK FOOTER //
// ./src/locales/lang/zh.js